import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSpaData } from "../context/SpaDataContext";
import { useBooking } from "../context/BookingContext";
import { Reveal } from "../components/Reveal";
import { TherapistCard } from "../components/TherapistCard";
import { Seo } from "../components/Seo";

export default function Therapists() {
  const { t } = useLanguage();
  const { therapists } = useSpaData();
  const { openBooking } = useBooking();

  return (
    <div data-testid="therapists-page" className="mx-auto max-w-7xl px-5 pb-24 pt-32 sm:px-8 sm:pt-40">
      <Seo title={t("seo.therapists.title")} description={t("seo.therapists.desc")} />
      <Reveal>
        <p className="text-[10px] uppercase tracking-[0.45em] text-gold">{t("therapistsPage.label")}</p>
        <h1 className="mt-3 font-display text-4xl font-light text-foreground sm:text-5xl lg:text-6xl">
          {t("therapistsPage.title")}
        </h1>
        <p className="mt-4 max-w-xl text-sm text-foreground/72">{t("therapistsPage.subtitle")}</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-3">
        {therapists.map((th, i) => (
          <Reveal key={th.slug} delay={(i % 3) * 0.1}>
            <TherapistCard therapist={th} />
          </Reveal>
        ))}
      </div>

      {/* Shortcuts */}
      <Reveal>
        <div className="mt-20 grid gap-6 sm:grid-cols-2">
          <Link
            data-testid="therapists-to-massages"
            to="/massagens"
            className="group rounded-2xl border border-foreground/8 bg-card p-8 transition-colors duration-300 hover:border-gold/40"
          >
            <p className="text-[10px] uppercase tracking-[0.35em] text-gold">{t("nav.massages")}</p>
            <h3 className="mt-2 font-display text-2xl text-foreground">{t("explore.discoverMassages")}</h3>
            <p className="mt-2 text-sm text-foreground/65">{t("explore.discoverMassagesDesc")}</p>
            <span className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold">
              {t("services.viewAll")}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
            </span>
          </Link>
          <button
            data-testid="therapists-book-cta"
            onClick={() => openBooking()}
            className="group rounded-2xl border border-gold/30 bg-gold/5 p-8 text-left transition-colors duration-300 hover:bg-gold/10"
          >
            <p className="text-[10px] uppercase tracking-[0.35em] text-gold">WhatsApp</p>
            <h3 className="mt-2 font-display text-2xl text-foreground">{t("explore.bookCta")}</h3>
            <p className="mt-2 text-sm text-foreground/65">{t("explore.bookCtaDesc")}</p>
            <span className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold">
              {t("nav.book")}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
            </span>
          </button>
        </div>
      </Reveal>
    </div>
  );
}
